import { WhatsAppMessage } from '../types/WhatsAppMessage';
import { apiService } from './apiService';

const WhatsAppApiService = {

    sendMessage: async (data: WhatsAppMessage, signal?: AbortSignal) => {
        try {
            const response = await apiService.post('/whatsapp-api/', data, {
                signal,
            });

            return response;

        } catch (error: any) {
            console.error("Error in createPatient:", error);

            return {
                message: error.message || "An error occurred while adding the patient.",
                error,
            };
        }
    },

};

export default WhatsAppApiService;
